export default __webpack_public_path__ + "static/media/bg-pattern-home-5.95a2a621.svg";